export default __webpack_public_path__ + "static/media/smarthome.85797417.jpeg";